import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { toast } from 'react-toastify';

const Header = ({ title, searchPlaceholder = "Search Patients...", notifications = 3 }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [notificationsOpen, setNotificationsOpen] = useState(false);
  const [profileOpen, setProfileOpen] = useState(false);
  const navigate = useNavigate();

  const handleSearch = (e) => {
    if (e.key === 'Enter' && searchQuery.trim()) {
      toast.info(`Searching for: "${searchQuery}"`);
      // In a real implementation, this would search through patients or other data
      if (searchQuery.toLowerCase().includes('patient:')) {
        // Example of conditional navigation based on search type
        const patientName = searchQuery.split(':')[1].trim();
        toast.success(`Navigating to patient: ${patientName}`);
        // Navigate to a placeholder patient ID
        navigate('/patient/123');
      }
    }
  };

  const handleNotificationClick = () => {
    setNotificationsOpen(!notificationsOpen);
    setProfileOpen(false);
  };

  const handleProfileClick = () => {
    setProfileOpen(!profileOpen);
    setNotificationsOpen(false);
  };

  return (
    <div className="flex items-center justify-between w-full bg-gray-800 text-white p-3 relative">
      {/* Logo as a link to home */}
      <Link to="/" className="text-xl font-bold hover:text-blue-300 transition-colors">
        OncoCatalyst
      </Link>
     
      <div className="flex-1 mx-4 relative">
        <input
          type="text"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          onKeyDown={handleSearch}
          placeholder={searchPlaceholder}
          className="w-full max-w-md py-2 px-4 rounded-full bg-gray-700 text-white"
        />
      </div>
     
      <div className="flex items-center">
        <div 
          className="relative mr-3 cursor-pointer" 
          onClick={handleNotificationClick}
        >
          <div className="w-10 h-10 rounded-full bg-blue-600 flex items-center justify-center">
            {notifications}
          </div>
          
          {/* Notifications dropdown */}
          {notificationsOpen && (
            <div className="absolute right-0 mt-2 w-64 bg-white rounded-lg shadow-lg z-20">
              <div className="p-3 border-b border-gray-200">
                <div className="text-gray-800 font-medium">Notifications</div>
              </div>
              <div className="max-h-64 overflow-y-auto">
                <div className="p-3 border-b border-gray-100 hover:bg-gray-50 cursor-pointer">
                  <div className="text-sm text-gray-800">New lab results for John Doe</div>
                  <div className="text-xs text-gray-500">10 minutes ago</div>
                </div>
                <div className="p-3 border-b border-gray-100 hover:bg-gray-50 cursor-pointer">
                  <div className="text-sm text-gray-800">Treatment plan updated for Sarah Smith</div>
                  <div className="text-xs text-gray-500">1 hour ago</div>
                </div>
                <div className="p-3 hover:bg-gray-50 cursor-pointer">
                  <div className="text-sm text-gray-800">Oncology consult scheduled with Dr. Wilson</div>
                  <div className="text-xs text-gray-500">Yesterday</div>
                </div>
              </div>
              <div className="p-2 text-center border-t border-gray-200">
                <button 
                  className="text-blue-500 text-sm hover:text-blue-600"
                  onClick={() => {
                    toast.info("Viewing all notifications");
                    setNotificationsOpen(false);
                  }}
                >
                  View All
                </button>
              </div>
            </div>
          )}
        </div>
        
        <div 
          className="w-10 h-10 rounded-full bg-green-500 flex items-center justify-center cursor-pointer"
          onClick={handleProfileClick}
        >
          DR
          
          {/* Profile dropdown */}
          {profileOpen && (
            <div className="absolute right-0 top-12 mt-2 w-48 bg-white rounded-lg shadow-lg z-20">
              <div className="p-3 border-b border-gray-200">
                <div className="text-gray-800 font-medium">Dr. Roberts</div>
                <div className="text-xs text-gray-500">Oncologist</div>
              </div>
              <div>
                <div 
                  className="p-3 border-b border-gray-100 hover:bg-gray-50 cursor-pointer text-gray-700"
                  onClick={() => {
                    toast.info("Navigating to profile settings");
                    navigate('/settings');
                    setProfileOpen(false);
                  }}
                >
                  Profile Settings
                </div>
                <div 
                  className="p-3 border-b border-gray-100 hover:bg-gray-50 cursor-pointer text-gray-700"
                  onClick={() => {
                    toast.info("Changing preferences");
                    setProfileOpen(false);
                  }}
                >
                  Preferences
                </div>
                <div 
                  className="p-3 hover:bg-gray-50 cursor-pointer text-gray-700"
                  onClick={() => {
                    toast.success("Successfully logged out");
                    setProfileOpen(false);
                  }}
                >
                  Log Out
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Header;